import { render, staticRenderFns } from "./edcContentDetail.vue?vue&type=template&id=beb3d77e&"
import script from "./edcContentDetail.vue?vue&type=script&lang=js&"
export * from "./edcContentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports